import { createApp } from 'vue'
import svgSprite from '../../shared_components/svgSprite.js';
import App from './App.vue'
import { install } from 'vue3-recaptcha-v2'
import { recaptcha_v2_site_key } from "./constants/envrionment";

const app = createApp(App)
app.use(svgSprite);

app.use(install, {
    sitekey: recaptcha_v2_site_key,
    cnDomains: false,
})

app.mount('#barcodeList')
